export default __webpack_public_path__ + "static/2 - Új ház villamoshálózatának kiépítése-a4a08d8d9a8f157d3ec66563ccc8e02b.jpg";